/* Joyce Giraud Beauty — empty-cart Best Sellers grid (vanilla JS).
   Fills the shells rendered by snippets/cart-empty-bestsellers.liquid in the
   cart drawer (#jgeb-drawer) and on the /cart page (#jgeb-page).
   - Six products in a fixed order; a sold-out or unavailable one is skipped
     and the grid is topped up with Ultimate Beauty Sleep.
   - "+ ADD" adds the product's one-time variant (quantity 1, no selling
     plan); a product with no purchasable one-time variant shows "VIEW".
   - After an add, the drawer refreshes through the theme's own
     window.BloomCart.refresh() (it switches to the filled state by itself);
     the /cart page reloads into the filled cart.
   - While the drawer is empty, it gets the class "jgeb-is-empty" so the
     Subtotal / Checkout footer is hidden (see assets/cart-empty-bestsellers.css).
   Product data mirrors assets/cart-upsell.js (same one-time handles). */
(function () {
  'use strict';
  if (window.JGEmptyBestSellers) return;

  /* show: product the card displays and links to.
     buy: product whose one-time variant "+ ADD" puts in the bag.
     image: product whose featured image is used (the multi-bottle shot the
     collection pages use). */
  var PRODUCTS = [
    { show: 'ultimate-hair-strength-pro-supplements', buy: 'ultimate-hair-strength-pro-supplements-30-days-parked', image: 'ultimate-hair-strength-pro-supplements' },
    { show: 'keratin-therapy-scalp-detox', buy: 'keratin-therapy-scalp-detox', image: 'keratin-therapy-scalp-detox-60-days-copy' },
    { show: 'ultimate-beauty-gummies-90-days', buy: 'ultimate-beauty-gummies-copy', image: 'ultimate-beauty-gummies-90-days' },
    { show: 'the-root-of-goodness-3-piece-system', buy: 'the-root-of-goodness-3-piece-system', image: 'the-root-of-goodness-3-piece-system' },
    { show: '2-minute-miracle-hair-mask', buy: '2-minute-miracle-hair-mask', image: '2-minute-miracle-hair-mask' },
    { show: 'miracle-oil-blend', buy: 'miracle-oil-blend', image: 'miracle-oil-blend' }
  ];
  var FALLBACK = { show: 'ultimate-beauty-sleep-transform-your-skin-while-you-sleep', buy: 'ultimate-beauty-sleep-transform-your-skin-while-you-sleep', image: 'ultimate-beauty-sleep-30-days-copy-1' };
  var ERROR_TEXT = 'Sorry, this item could not be added. Please try again.';

  /* ── Helpers ── */
  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Same day-count cleanup as snippets/bloom-card-clean-title.liquid */
  function cleanTitle(t) {
    return String(t || '').replace(/\s*[-\/]?\s*\b(30|60|90)[\s-]DAYS?\s*$/i, '').trim();
  }
  /* Link URLs for the four standalone families, rendered by
     snippets/standalone-product-url.liquid into [data-jgeb-urls] */
  var standaloneUrls = null;
  function standaloneUrl(handle) {
    if (!standaloneUrls) {
      standaloneUrls = {};
      try {
        var el = document.querySelector('[data-jgeb-urls]');
        if (el) standaloneUrls = JSON.parse(el.textContent) || {};
      } catch (e) { standaloneUrls = {}; }
    }
    return standaloneUrls[handle] || '';
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* Card data for one product, or null if it must be skipped. */
  function card(p) {
    return Promise.all([getProduct(p.show), getProduct(p.buy), getProduct(p.image)]).then(function (r) {
      var show = r[0], buy = r[1], img = r[2] || show;
      if (!show || !show.available) return null;
      var variant = buy ? buy.variants.filter(function (v) { return v.available && !v.requires_selling_plan; })[0] || null : null;
      return {
        title: cleanTitle(show.title),
        url: standaloneUrl(show.handle) || show.url || ('/products/' + show.handle),
        image: sizedImage((img && img.featured_image) || show.featured_image, 400),
        variantId: variant ? variant.id : null,
        price: variant ? variant.price : null,
        compare: variant && variant.compare_at_price > variant.price ? variant.compare_at_price : null
      };
    });
  }

  var cardsPromise = null;
  function loadCards() {
    if (!cardsPromise) {
      cardsPromise = Promise.all(PRODUCTS.map(card)).then(function (list) {
        list = list.filter(Boolean);
        if (list.length < PRODUCTS.length) {
          return card(FALLBACK).then(function (extra) {
            if (extra) list.push(extra);
            return list.slice(0, PRODUCTS.length);
          });
        }
        return list;
      });
    }
    return cardsPromise;
  }

  function cardHTML(c) {
    var price = c.price != null
      ? '<p class="jgeb__price"><span class="jgeb__now">' + money(c.price) + '</span>'
        + (c.compare ? ' <s class="jgeb__was">' + money(c.compare) + '</s>' : '') + '</p>'
      : '<p class="jgeb__price"></p>';
    var action = c.variantId
      ? '<button type="button" class="jgeb__add" data-jgeb-add="' + c.variantId + '" aria-label="Add ' + esc(c.title) + ' to your bag">+ ADD</button>'
      : '<a class="jgeb__add jgeb__add--view" href="' + esc(c.url) + '" aria-label="View ' + esc(c.title) + '">VIEW</a>';
    return '<li class="jgeb__card">'
      + '<a class="jgeb__media" href="' + esc(c.url) + '" tabindex="-1" aria-hidden="true">'
      + (c.image ? '<img src="' + esc(c.image) + '" alt="" width="200" height="200">' : '')
      + '</a>'
      + '<a class="jgeb__name" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'
      + price
      + action
      + '</li>';
  }

  function fill(block) {
    if (!block || block.getAttribute('data-jgeb-filled') === '1') return;
    block.setAttribute('data-jgeb-filled', '1');
    var grid = block.querySelector('[data-jgeb-grid]');
    loadCards().then(function (cards) {
      if (!grid) return;
      if (!cards.length) { grid.hidden = true; return; }
      grid.innerHTML = cards.map(cardHTML).join('');
    }).catch(function () {
      if (grid) grid.hidden = true;
    });
  }

  /* ── Add (one-time variant, quantity 1, no selling plan) ── */
  var adding = false;
  function showError(block, show) {
    var err = block && block.querySelector('[data-jgeb-error]');
    if (!err) return;
    err.textContent = show ? ERROR_TEXT : '';
    err.hidden = !show;
  }
  function resetButton(btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-loading');
    btn.textContent = '+ ADD';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jgeb-add]');
    if (!btn) return;
    e.preventDefault();
    if (adding || btn.disabled) return;
    adding = true;
    var block = btn.closest('.jgeb');
    var ctx = block ? block.getAttribute('data-jgeb-context') : 'drawer';
    showError(block, false);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.textContent = 'ADDING';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-jgeb-add'), 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (ctx === 'page') { window.location.reload(); return; }
      if (window.BloomCart && typeof window.BloomCart.refresh === 'function') return window.BloomCart.refresh();
    }).then(function () {
      if (ctx !== 'page') { adding = false; resetButton(btn); }
    }).catch(function () {
      adding = false;
      resetButton(btn);
      showError(block, true);
    });
  });

  /* ── Wiring ── */
  function init() {
    var pageBlock = document.getElementById('jgeb-page');
    if (pageBlock) fill(pageBlock);

    var drawer = document.getElementById('bloom-cart-drawer');
    var empty = document.getElementById('bloom-cart-empty');
    var drawerBlock = document.getElementById('jgeb-drawer');
    if (!drawer || !empty || !drawerBlock) return;
    /* Products load the first time the empty drawer is actually opened,
       not on every page view. */
    function sync() {
      var isEmpty = empty.style.display === 'flex';
      drawer.classList.toggle('jgeb-is-empty', isEmpty);
      if (isEmpty && drawer.classList.contains('is-open')) fill(drawerBlock);
    }
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(empty, { attributes: true, attributeFilter: ['style'] });
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    sync();
  }

  window.JGEmptyBestSellers = { fill: fill };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
